// src/Layouts/Layout.js
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Layout() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.body.dir = i18n.language === "ar" ? "rtl" : "ltr";
    return () => { document.body.dir = "ltr"; };
  }, [i18n.language]);

  return (
    <>
      <Header />
      <main className="dajc-main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
